import * as React from 'react';
import { VideosNav, VideosList } from './components'
import { DashboardContainer } from '../components';
import { useSelector } from 'react-redux'
import { selectAllVideos} from 'features/videos/videosSlice'
import ShowStats from './components/ShowStats';
import { Alert } from '@mui/material';

const Videos = (props) => {

  const [statsOpen,setStatsOpen] = React.useState(true);
  const items = useSelector(selectAllVideos);

  return (

      <DashboardContainer>
        <VideosNav onStats={setStatsOpen} isStatsOpen={statsOpen} />

        { statsOpen && <ShowStats />}
        { items && 
        <>
          { items.length != 0 ? (

            <VideosList
              items={items}
              withFilters
              withActions
              withDrawer
            />

          ) : (
            <>
            <Alert severity="warning" sx={{mt:1}}>Nothing to show</Alert>
            </>
          )
          }
        </>
        }

      </DashboardContainer>

  );


}

export default Videos;